import { AnchorHTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

type LinkTextProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children?: ReactNode;
  underline?: boolean;
};

/** @deprecated */
const LinkText = styled.a<LinkTextProps>`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.link};

  ${({ underline }) =>
    underline &&
    css`
      :hover {
        text-decoration: underline;
      }
    `}

  :hover {
    font-weight: 600;
  }
`;

export default LinkText;
